/*
 * @LastEditors: Jacky
 * @LastEditTime: 2023-04-06 10:53:24
 * @FilePath: /mojito-xy-interface/src/utils/useResponse.ts
 * Copyright (c) 2023 by Jacky, All Rights Reserved.
 */
import React, { useEffect } from "react";

export function useResponsive() {
  const MobileWidth = 768;
  const TabletWidth = 1200;
  const [isMobile, setIsModile] = React.useState(false);
  const [isTablet, setIsTablet] = React.useState(false);
  const calc = () => {
    const width =
      document.body.clientWidth ?? document.documentElement.clientWidth;
    if (width <= MobileWidth) {
      setIsModile(true);
    } else {
      setIsModile(false);
    }
    if (width > MobileWidth && width <= TabletWidth) {
      setIsTablet(true);
    } else {
      setIsTablet(false);
    }
  };
  useEffect(() => {
    calc();
    window.addEventListener("resize", calc);
    return () => {
      window.removeEventListener("resize", calc);
    };
  }, []);

  const m = isMobile;
  const t = isTablet;
  const p = !(m || t);

  return { isMobile: m, isTablet: t, isPC: p };
}
